module.exports = __webpack_public_path__ + "static/media/iep-userflow01.b5fb60cd.png";